function toggleCart() {
  const cartDrawer = document.getElementById('cart-drawer');
  const cartPanel = cartDrawer?.querySelector('[data-cart-panel]');
  
  // Prevent multiple clicks during transition
  if (cartDrawer?.classList.contains('transitioning')) {
    return;
  }

  if (!cartDrawer || !cartPanel) {
    return;
  }

  try {
    const isHidden = cartDrawer.classList.contains('invisible');
    
    cartDrawer.classList.add('transitioning');
    
    if (isHidden) {
      // Fetch updated cart content before showing drawer
      fetch('/?section_id=cart-drawer')
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newContent = doc.querySelector('[data-cart-content]');
          const cartContent = cartDrawer.querySelector('[data-cart-content]');
          const newSubtotal = doc.querySelector('[data-cart-subtotal]');
          const cartSubtotal = cartDrawer.querySelector('[data-cart-subtotal]');
          const checkoutButton = cartDrawer.querySelector('a[href="/checkout"]');
          
          if (newContent && cartContent) {
            cartContent.innerHTML = newContent.innerHTML;
          }
          
          // Update subtotal
          if (newSubtotal && cartSubtotal) {
            cartSubtotal.innerHTML = newSubtotal.innerHTML;
          }
          
          // Update checkout button state
          if (checkoutButton) {
            const itemCount = doc.querySelectorAll('[data-cart-item]').length;
            if (itemCount === 0) {
              checkoutButton.setAttribute('disabled', '');
              checkoutButton.style.opacity = '0.5';
              checkoutButton.style.pointerEvents = 'none';
            } else {
              checkoutButton.removeAttribute('disabled');
              checkoutButton.style.opacity = '';
              checkoutButton.style.pointerEvents = '';
            }
          }
        });

      cartDrawer.classList.remove('invisible', 'opacity-0');
      cartPanel.classList.remove('translate-x-full');
      // Don't hide the header when opening cart
      document.body.style.overflow = 'hidden';
      document.getElementById('navbar').style.display = 'block';
      setTimeout(() => {
        cartDrawer.classList.remove('transitioning');
      }, 300);
    } else {
      cartDrawer.classList.add('opacity-0');
      cartPanel.classList.add('translate-x-full');
      document.body.style.overflow = '';
      setTimeout(() => {
        cartDrawer.classList.add('invisible');
        setTimeout(() => {
          cartDrawer.classList.remove('transitioning');
        }, 100);
      }, 300);
    }

  } catch (error) {
    cartDrawer.classList.remove('transitioning');
  }
}

function closeCart() {
  const cartDrawer = document.getElementById('cart-drawer');
  const cartPanel = document.getElementById('cart-panel');
  
  cartDrawer.classList.add('opacity-0');
  cartPanel.classList.add('translate-x-full');
  document.body.style.overflow = '';
  setTimeout(() => {
    cartDrawer.classList.add('invisible');
  }, 500);
}

document.addEventListener('DOMContentLoaded', function() {
  // Handle cart:open event
  window.addEventListener('cart:open', async () => {
    const cartDrawer = document.getElementById('cart-drawer');
    const cartPanel = cartDrawer?.querySelector('[data-cart-panel]');
    const cartContent = cartDrawer?.querySelector('[data-cart-content]');
    
    if (!cartDrawer || !cartPanel || !cartContent) {
      return;
    }

    try {
      const response = await fetch('/?section_id=cart-drawer');
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContent = doc.querySelector('[data-cart-content]');

      if (newContent) {
        cartContent.innerHTML = newContent.innerHTML;
      }

      // Show drawer
      cartDrawer.classList.remove('invisible', 'opacity-0');
      cartPanel.classList.remove('translate-x-full');
      document.body.style.overflow = 'hidden';
    } catch (error) {
    }
  });

  // Handle cart trigger clicks
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');
  cartTriggers.forEach(trigger => {
    const handleCartClick = function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleCart();
    };
    
    // Remove any existing listeners and add new one
    trigger.removeEventListener('click', handleCartClick);
    trigger.addEventListener('click', handleCartClick);
  });

  // Handle cart close
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = cartDrawer?.querySelector('[data-cart-overlay]');
  const closeButtons = cartDrawer?.querySelectorAll('[data-cart-close]');

  cartOverlay?.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    toggleCart();
  });

  closeButtons?.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleCart();
    });
  });

  // Prevent cart panel clicks from closing
  const cartPanel = document.getElementById('cart-panel');
  if (cartPanel) {
    cartPanel.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  }

  // Quantity Controls
  const quantityControls = document.querySelectorAll('[data-quantity-control]');
  
  if (quantityControls.length > 0) {
    quantityControls.forEach(control => {
      control.addEventListener('click', async () => {
        const button = control;
        const wrapper = button.closest('[data-quantity-wrapper]');
        const input = wrapper.querySelector('[data-quantity-input]');
        const lineItem = button.closest('[data-line-item]');
        const lineItemKey = lineItem.dataset.lineItemKey;
        const currentQty = parseInt(input.value);
        const isIncrement = button.dataset.quantityControl === 'increment';
        
        // Calculate new quantity
        const newQty = isIncrement ? currentQty + 1 : currentQty - 1;
        
        if (newQty < 1) {
          // Remove item if quantity would be less than 1
          try {
            const response = await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: lineItemKey,
                quantity: 0
              })
            });
            
            if (!response.ok) throw new Error('Cart update failed');
            
            const cartData = await response.json();
            updateCart(cartData);
          } catch (error) {
          }
        } else {
          // Update quantity
          try {
            const response = await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: lineItemKey,
                quantity: newQty
              })
            });
            
            if (!response.ok) throw new Error('Cart update failed');
            
            const cartData = await response.json();
            input.value = newQty;
            updateCart(cartData);
          } catch (error) {
          }
        }
      });
    });
  }
});

// Function to update cart UI
function updateCart(cartData) {
  // First, update the cart count in the header
  const cartCounts = document.querySelectorAll('[data-cart-count]');
  cartCounts.forEach(count => {
    count.textContent = cartData.item_count;
  });
  
  // Update mobile cart text
  const mobileCartTrigger = document.querySelector('.md\\:hidden [data-cart-trigger]');
  if (mobileCartTrigger) {
    mobileCartTrigger.textContent = `Cart (${cartData.item_count})`;
  }
  
  // Then, fetch and update the cart drawer contents
  fetch('/?sections=cart-drawer')
    .then(response => response.json())
    .then(sections => {
      const cartDrawerHTML = sections['cart-drawer'];
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = cartDrawerHTML;
      
      // Get the new cart content
      const newCartContent = tempDiv.querySelector('[data-cart-items-container]');
      const currentCartContent = document.querySelector('[data-cart-items-container]');
      
      if (newCartContent && currentCartContent) {
        currentCartContent.innerHTML = newCartContent.innerHTML;
      }
      
      // Update subtotal
      const subtotalElement = document.querySelector('[data-cart-subtotal]');
      if (subtotalElement) {
        subtotalElement.textContent = formatMoney(cartData.items_subtotal_price);
      }
      
      // Show/hide cart footer
      const cartFooter = document.querySelector('[data-cart-footer]');
      if (cartFooter) {
        cartFooter.style.display = cartData.item_count > 0 ? 'block' : 'none';
      }
      
      // Reattach event listeners
      attachQuantityControlListeners();
    })
    .catch(error => {
    });
}

// Helper function to format money
function formatMoney(cents) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(cents / 100);
}

// Function to attach quantity control listeners
function attachQuantityControlListeners() {
  const quantityControls = document.querySelectorAll('[data-quantity-control]');
  
  quantityControls.forEach(control => {
    control.addEventListener('click', handleQuantityChange);
  });
}

// Quantity change handler
async function handleQuantityChange(event) {
  const button = event.currentTarget;
  const wrapper = button.closest('[data-quantity-wrapper]');
  const input = wrapper.querySelector('[data-quantity-input]');
  const lineItem = button.closest('[data-line-item]');
  const lineItemKey = lineItem.dataset.lineItemKey;
  const currentQty = parseInt(input.value);
  const isIncrement = button.dataset.quantityControl === 'increment';
  
  const newQty = isIncrement ? currentQty + 1 : currentQty - 1;
  
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: lineItemKey,
        quantity: newQty
      })
    });
    
    if (!response.ok) throw new Error('Cart update failed');
    
    const cartData = await response.json();
    updateCart(cartData);
  } catch (error) {
  }
} 